const routes = [
  {
    path: "/manutencao-do-tipo-curso",
    name: "manutencao-do-tipo-curso",
    meta: {
      allowedPermissions: ["tipo_curso_list"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import("@/views/ManutencaoDoTipoCurso/ManutencaoDoTipoCursoHome.vue"),
  },

  {
    path: "/manutencao-do-tipo-curso/novo",
    name: "manutencao-do-tipo-curso-novo",
    meta: {
      allowedPermissions: ["tipo_curso_insert"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import("@/views/ManutencaoDoTipoCurso/ManutencaoDoTipoCursoCad.vue"),
  },

  {
    path: "/manutencao-do-tipo-curso/editar/:id",
    name: "manutencao-do-tipo-curso-editar",
    meta: {
      allowedPermissions: ["tipo_curso_update"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import("@/views/ManutencaoDoTipoCurso/ManutencaoDoTipoCursoEdit.vue"),
  },
];

export default routes;
